export const isTouchDevice =
    typeof window !== 'undefined' && typeof window.ontouchstart !== 'undefined';
